import React from 'react';
import classNames from 'classnames';
import PropTypes from 'constants/PropTypes';
import ValidationMessage from '../ValidationMessage';

const icon = (error, touched, showSuccessOnValid) => {
    if (touched) {
        const errorClass = error ? 'form-control-feedback glyphicon-remove' : '';
        const successClass =
            !error && showSuccessOnValid ? 'form-control-feedback glyphicon-ok' : '';
        return <span className={`${errorClass}${successClass}`} />;
    }

    return null;
};

const Component = ({ error, touched, showSuccessOnValid, className, children }) => {
    const classes = classNames('form-group', className, {
        'has-feedback has-error': error && touched,
        'has-feedback has-success': !error && touched && showSuccessOnValid,
    });
    return (
        <div className={classes}>
            {children}
            {icon(error, touched, showSuccessOnValid)}
            <ValidationMessage error={error} touched={touched} />
        </div>
    );
};

Component.displayName = 'FormGroup';

Component.propTypes = {
    error: PropTypes.bool,
    touched: PropTypes.bool,
    children: PropTypes.node.isRequired,
    showSuccessOnValid: PropTypes.bool,
    className: PropTypes.string,
};

export default Component;
